import { createContext } from 'react';
import EditMPCheckoutConfigContext from 'types/contexts/EditMPCheckoutConfigContext';

export default createContext({} as EditMPCheckoutConfigContext);
